import "./FamilyTravel.module.css";
import Header from "@/reusable_sections/Header";
import Hygiene from "./sections/Hygiene";
import Essentials from "./sections/Essentials";
import Safety from "./sections/Safety";
import Footer from "@/reusable_sections/Footer";
export default function FamilyTravelPage() {
  return <div>
      <Header />
      <Hygiene />
      <Essentials />
      <Safety />
      <Footer />
    </div>;
}